import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUrlParams } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";
import "./Theme.css";
import "./ScoradScore.css";

const ScoradScore = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();
  const [scoreData, setScoreData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  useEffect(() => {
    lifestyleApi.fetchScore()
      .then((res) => setScoreData(res.data.data || null))
      .catch((err) => console.error("fetchScore:", err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="scorad-score-loading">{t("common.loading")}</div>;

  return (
    <section className="scorad-score-page">
      <div className="scorad-score-grid">
        <div className="scorad-score-card">
          <span className="scorad-score-label">BSA</span>
          <span className="scorad-score-val">{scoreData?.bsaScore ?? "--"}</span>
        </div>
        <div className="scorad-score-card">
          <span className="scorad-score-label">IO Sign</span>
          <span className="scorad-score-val">{scoreData?.ioSignScore ?? "--"}</span>
        </div>
        <div className="scorad-score-card">
          <span className="scorad-score-label">IO Symptom</span>
          <span className="scorad-score-val">{scoreData?.ioSymptomScore ?? "--"}</span>
        </div>
        <div className="scorad-score-card scorad-score-total">
          <span className="scorad-score-label">SCORAD</span>
          <span className="scorad-score-val">{scoreData?.scoradScore ?? "--"}</span>
        </div>
      </div>
    </section>
  );
};

export default ScoradScore;
